import { ComponentProps, FunctionComponent } from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';

export const Link: FunctionComponent<
  ComponentProps<typeof ReactRouterLink>
> = ({ className = '', ...props }) => (
  <ReactRouterLink
    {...props}
    className={`${className} text-brand-blue bg-transparent text-sm outline-none
focus:outline-none active:text-purple-500 ease-linear transition-all duration-150 cursor-pointer`}
  />
);
